import styled, { keyframes } from 'styled-components';
import { colors } from 'assets/styled/tokens';

// ─── Shell do Modal ───────────────────────────────────────────────────────────

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalBody = styled.div`
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 1248px;
  max-height: 563px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);

  @media (max-width: 767px) {
    border-radius: 0;
    max-width: 100%;
    max-height: 100%;
    height: 100%;
  }
`;

// ─── Cabeçalho do Modal ───────────────────────────────────────────────────────

export const HeaderColorBar = styled.div<{ color: string }>`
  height: 6px;
  background: ${({ isPendente }) => (isPendente ? '#F9DDEC' : '#988202')};
  border-radius: 8px 8px 0 0;
  flex-shrink: 0;
`;

export const HeaderContent = styled.div<{ isPendente?: boolean }>`
  padding: 16px 20px 12px;
  border-bottom: 1px solid ${({ isPendente }) => (isPendente ? '#BB2D7C' : '#988202')};
  flex-shrink: 0;
  background: ${({ isPendente }) => (isPendente ? '#F9DDEC' : '#F7EFC0')};
`;

export const HeaderTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const HeaderMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const StatusBadge = styled.span<{ atrasada: boolean; realizada: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${({ atrasada, realizada }) => (realizada ? '#4CAF50' : atrasada ? '#E53935' : '#9E9E9E')};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
`;

export const HeaderTitle = styled.h2<{ isPendente?: boolean }>`
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  color: ${({ isPendente }) => (isPendente ? '#BB2D7C' : '#705F01')};
  margin: 0;
`;

export const CloseButton = styled.button`
  border: 1px solid #e8e1de;
  height: 32px;
  width: 32px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666;
  background-color: #fff;
  border-radius: 6px;
  svg path {
    fill: #666;
  }

  &:hover {
    color: #333;
  }
`;

export const HeaderFields = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 24px;
  margin-top: 8px;
`;

export const HeaderField = styled.span<{ isPendente?: boolean }>`
  font-family: Roboto;
  font-size: 13px;
  color: #555;

  strong {
    color: ${({ isPendente }) => (isPendente ? '#BB2D7C' : '#705F01')};
    font-weight: 600;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding: 16px;
`;

// ─── Botões de ação ───────────────────────────────────────────────────────────

export const EditButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 32px;
  min-width: 173px;
  padding: 0 12px;
  border-radius: 6px;
  background: ${colors.primary};
  color: #fff;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 600;
  border: none;
  cursor: pointer;

  svg path {
    fill: #fff;
  }

  &:hover {
    opacity: 0.88;
  }
`;

export const DangerButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 6px;
  background: transparent;
  color: #c25346;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid #e8e1de;
  cursor: pointer;

  &:hover {
    background: #fff0ee;
  }
`;

export const RestoreButton = styled(DangerButton)`
  color: #2780eb;

  &:hover {
    background: #e8f0fd;
  }
`;

// ─── Confirmação inline ───────────────────────────────────────────────────────

export const ConfirmRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0 0;
  font-family: Roboto;
  font-size: 13px;
  color: #444;
`;

export const ConfirmButton = styled.button<{ variant: 'confirm' | 'cancel' }>`
  padding: 4px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid ${({ variant }) => (variant === 'confirm' ? '#c25346' : '#ccc')};
  background: ${({ variant }) => (variant === 'confirm' ? '#c25346' : '#fff')};
  color: ${({ variant }) => (variant === 'confirm' ? '#fff' : '#555')};

  &:hover {
    opacity: 0.88;
  }
`;

// ─── Lista de atividades ──────────────────────────────────────────────────────

export const ActivityListWrapper = styled.div`
  overflow-y: auto;
  flex: 1;
  padding: 0 16px 16px;
`;

export const TableWrapper = styled.div`
  border: 1px solid #e8e1de;
  border-radius: 8px;
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: Roboto;
  font-size: 13px;
`;

export const Thead = styled.thead`
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const Th = styled.th`
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  color: #555;
  white-space: nowrap;
  border-bottom: 1px solid #e8e1de;
`;

export const Tr = styled.tr`
  border-bottom: 1px solid #f0ebe8;

  &:nth-child(odd) {
    background: #faf9f8;
  }

  &:nth-child(even) {
    background: #fff;
  }

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f0ebe8;
  }
`;

export const Td = styled.td`
  padding: 10px 12px;
  color: #333;
  vertical-align: middle;
`;

export const ExecutorList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ExecutorRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
`;

export const ExecutorAvatar = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

export const ExecutorAvatarPlaceholder = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #e0d8d4;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Roboto;
  font-size: 8px;
  font-weight: 700;
  color: #7a6e6a;
  flex-shrink: 0;
  text-transform: uppercase;
`;

export const WhatsAppLink = styled.a`
  display: flex;
  align-items: flex-start;
  gap: 5px;
  text-decoration: none;

  &:hover {
    opacity: 0.85;
  }
`;

export const WhatsAppExecutorName = styled.span`
  color: #25d366;
  text-decoration: underline;
  font-family: Roboto;
  font-size: 13px;
`;

export const StatusChip = styled.span<{ variant: 'green' | 'blue' | 'red' }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  background: ${({ variant }) => (variant === 'green' ? '#B4EDE3' : variant === 'red' ? '#FFDBD6' : '#CCE4FA')};
  color: ${({ variant }) => (variant === 'green' ? '#006552' : variant === 'red' ? '#923F35' : '#245E82')};
  border: 1px solid ${({ variant }) => (variant === 'green' ? '#94DFD2' : variant === 'red' ? '#F7C2BB' : '#B0D3EE')};
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  color: #888;
  font-family: Roboto;
  font-size: 14px;
`;

// ─── Modal de confirmação de exclusão ────────────────────────────────────────

export const ConfirmDeleteOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConfirmDeleteBox = styled.div`
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 440px;
  padding: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ConfirmDeleteHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ConfirmDeleteTitle = styled.h3`
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  color: #222;
  margin: 0;
`;

export const ConfirmDeleteCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #888;
  display: flex;
  align-items: center;

  &:hover {
    color: #333;
  }
`;

export const ConfirmDeleteWarning = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fdecea;
  border: 1px solid #f5c6c2;
  border-radius: 6px;
  padding: 12px 14px;
  font-family: Roboto;
  font-size: 13px;
  color: #b71c1c;
  line-height: 1.5;

  strong {
    font-weight: 700;
  }
`;

export const ConfirmDeleteLabel = styled.label`
  font-family: Roboto;
  font-size: 13px;
  color: #444;

  strong {
    font-weight: 700;
  }
`;

export const ConfirmDeleteInput = styled.input`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px 12px;
  font-family: Roboto;
  font-size: 14px;
  color: #222;
  outline: none;
  box-sizing: border-box;
  margin-top: 6px;

  &:focus {
    border-color: #c25346;
  }
`;

export const ConfirmDeleteActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const ConfirmDeleteCancelButton = styled.button`
  padding: 8px 20px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #fff;
  color: #555;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f5f3f1;
  }
`;

export const ConfirmDeleteSubmitButton = styled.button`
  padding: 8px 20px;
  border-radius: 6px;
  border: none;
  background: #c25346;
  color: #fff;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    opacity: 0.88;
  }
`;

// ─── Modal de restaurar ───────────────────────────────────────────────────────

export const ConfirmRestoreCloseButton = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid #e8e1de;
  border-radius: 6px;
  cursor: pointer;
  color: #888;
  flex-shrink: 0;

  &:hover {
    color: #333;
    border-color: #ccc;
  }
`;

export const ConfirmRestoreCheckboxRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-family: Roboto;
  font-size: 13px;
  color: #444;
  line-height: 1.4;

  input[type='checkbox'] {
    margin-top: 2px;
    flex-shrink: 0;
    cursor: pointer;
  }

  label {
    cursor: pointer;
  }
`;

export const ConfirmRestoreButton = styled.button`
  align-self: flex-start;
  padding: 10px 20px;
  border-radius: 6px;
  border: none;
  background: ${colors.primary};
  color: #fff;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    opacity: 0.88;
  }
`;

// ─── Kebab menu por linha ─────────────────────────────────────────────────────

export const RowActionsCell = styled.td`
  padding: 0 8px;
  width: 32px;
  text-align: center;
  vertical-align: middle;
  position: relative;
`;

export const KebabButton = styled.button`
  background: #fff;
  border: 1px solid #e8e1de;
  cursor: pointer;
  padding: 0;
  border-radius: 4px;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;

  &:hover {
    background: #f0ebe8;
    color: #333;
  }
`;

export const RowMenuWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const RowMenu = styled.ul`
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  background: #fff;
  border: 1px solid #e8e1de;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  min-width: 140px;
  list-style: none;
  margin: 0;
  padding: 4px 0;
  z-index: 100;
`;

export const PortalRowMenu = styled.ul`
  position: fixed;
  background: #fff;
  border: 1px solid #e8e1de;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  width: max-content;
  list-style: none;
  margin: 0;
  padding: 4px 0;
  z-index: 9999;
`;

export const RowMenuItem = styled.li<{ danger?: boolean; restore?: boolean }>`
  padding: 6px 12px;
  font-family: Roboto;
  font-size: 13px;
  color: ${({ danger, restore }) => (danger ? '#c25346' : restore ? '#7F746A' : '#333')};
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: ${({ danger }) => (danger ? '#fff0ee' : '#f5f3f1')};
  }
`;

// ─── Tabela de edição ─────────────────────────────────────────────────────────

export const EditBulkThead = styled.thead`
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 200;

  tr {
    height: 92px;
  }

  th {
    border-bottom: 1px solid #e8e1de;
  }

  th:nth-child(2) {
    width: 180px;
  }
`;

export const EditTr = styled.tr<{ selected?: boolean }>`
  background: ${({ selected }) => (selected ? '#fef9f0' : '#fff')};

  td {
    border-bottom: 1px solid #f0ebe8;
  }

  &:last-child td {
    border-bottom: none;
  }
`;

export const EditCheckboxCell = styled.td`
  padding: 10px 8px 10px 12px;
  width: 28px;
  vertical-align: middle;
`;

export const EditMetaCell = styled.td`
  padding: 10px 12px;
  font-family: Roboto;
  font-size: 13px;
  color: #333;
  vertical-align: middle;
  width: 490px;
  max-width: 490px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EditInputCell = styled.td`
  padding: 6px 8px;
  vertical-align: middle;
  white-space: nowrap;
`;

export const EditActionsCell = styled.td`
  padding: 6px 8px 6px 0;
  vertical-align: middle;
  white-space: nowrap;
  text-align: right;
`;

export const EditActionsCellContent = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const EditBulkMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const EditBulkCount = styled.span`
  font-family: Roboto;
  font-size: 13px;
  font-weight: 600;
  color: #333;
`;

export const EditBulkLink = styled.span`
  font-family: Roboto;
  font-size: 13px;
  color: #7f746a;
  background: none;
  border: none;
  padding: 0;
`;

export const EditInput = styled.input`
  height: 32px;
  border: 1px solid #e8e1de;
  border-radius: 6px;
  padding: 0 10px;
  font-family: Roboto;
  font-size: 13px;
  color: #333;
  background: #fff;
  outline: none;
  width: 100%;

  &:focus {
    border-color: ${colors.primary};
  }

  &:disabled {
    background: #f5f3f1;
    color: #aaa;
    cursor: not-allowed;
  }
`;

export const EditDateInput = styled(EditInput).attrs({ type: 'date' })`
  width: 140px;
`;

export const EditTimeInput = styled(EditInput).attrs({ type: 'time' })`
  width: 100px;
`;

export const EditExecutorSelect = styled.select`
  height: 32px;
  border: 1px solid #e8e1de;
  border-radius: 6px;
  padding: 0 8px;
  font-family: Roboto;
  font-size: 13px;
  color: #333;
  background: #fff;
  outline: none;
  width: 170px;
  cursor: pointer;

  &:focus {
    border-color: ${colors.primary};
  }

  &:disabled {
    background: #f5f3f1;
    color: #aaa;
    cursor: not-allowed;
  }
`;

export const EditSaveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 20px;
  border-radius: 6px;
  background: ${colors.primary};
  color: #fff;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    opacity: 0.88;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

// ─── Mobile ActivityList ──────────────────────────────────────────────────────

export const DesktopOnly = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
`;

export const MobileOnly = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: block;
  }
`;

export const MobileCardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0;
`;

export const MobileCard = styled.div<{ even?: boolean }>`
  padding: 14px 16px;
  background: ${({ even }) => (even ? '#faf9f8' : '#fff')};
  border: 1px solid #e8e1de;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MobileCardTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const MobileCardTitle = styled.p`
  font-family: Roboto;
  font-size: 13px;
  font-weight: 400;
  color: #7f746a;
  margin: 0;
  line-height: 1.4;
`;

export const MobileCardTitleBold = styled.span`
  font-weight: 700;
  color: #1e1e1e;
`;

export const MobileCardFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MobileCardField = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

export const MobileCardFieldLabel = styled.span`
  font-family: Roboto;
  font-size: 13px;
  font-weight: 700;
  color: #1e1e1e;
  white-space: nowrap;
`;

export const MobileCardFieldValue = styled.span`
  font-family: Roboto;
  font-size: 13px;
  font-weight: 400;
  color: #7f746a;
`;

export const MobileCardExecutors = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const MobileCardExecutorLabel = styled.span`
  font-family: Roboto;
  font-size: 13px;
  font-weight: 700;
  color: #1e1e1e;
`;

// ─── Mobile EditActivityList ──────────────────────────────────────────────────

export const MobileEditWrapper = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;

export const MobileEditBulkHeader = styled.div`
  padding: 14px 16px 14px 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MobileEditBulkTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const MobileEditBottomBar = styled.div`
  position: sticky;
  bottom: 0;
  width: 100%;
  height: 56px;
  background: #fff;
  border-top: 1px solid #e8e1de;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10;
  flex-shrink: 0;
`;

export const MobileEditBulkCount = styled.span`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  color: #1e1e1e;
  flex: 1;
`;

export const MobileEditBulkLinkRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const MobileEditFieldRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
`;

export const MobileEditCard = styled.div<{ selected?: boolean }>`
  padding: 14px 16px;
  background: ${({ selected }) => (selected ? '#fef9f0' : '#fff')};
  border: 1px solid #e8e1de;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MobileEditCardTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MobileEditCardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
`;

export const MobileEditCardTitle = styled.p`
  font-family: Roboto;
  font-size: 13px;
  font-weight: 400;
  color: #7f746a;
  margin: 0;
  line-height: 1.4;
`;

export const MobileEditCardTitleBold = styled.span`
  font-weight: 700;
  color: #1e1e1e;
`;

export const MobileEditCardFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const OrangeCheckbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #ccc;
  border-radius: 3px;
  background: #fff;
  cursor: pointer;
  flex-shrink: 0;

  &:checked {
    background: #f38a00;
    border-color: #f38a00;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' fill='none'%3E%3Cpath d='M2 6l3 3 5-5' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 10px 10px;
  }

  &:indeterminate {
    background: #f38a00;
    border-color: #f38a00;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Crect x='2' y='5' width='8' height='2' fill='white' rx='1'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 10px 10px;
  }
`;

export const ExpandButton = styled.button`
  background: #fff;
  border: 1px solid #e8e1de;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #888;
  flex-shrink: 0;

  &:hover {
    background: #f0ebe8;
    color: #333;
  }
`;

// ─── Apply Changes Modal ─────────────────────────────────────────────────────

export const ApplyModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ApplyModalBox = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 400px;
  padding: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 767px) {
    width: calc(100% - 32px);
  }
`;

export const ApplyModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ApplyModalTitle = styled.h3`
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  color: #1e1e1e;
  margin: 0;
`;

export const ApplyModalCloseButton = styled.button`
  background: none;
  border: 1px solid #d0c8c4;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 1;
  color: #888;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: #f5f3f1;
    color: #333;
  }
`;

export const ApplyModalOption = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border: 1.5px solid ${({ selected }) => (selected ? '#f38a00' : '#e8e1de')};
  border-radius: 8px;
  cursor: pointer;
  background: ${({ selected }) => (selected ? '#fff9f0' : '#fff')};

  &:hover {
    border-color: #f38a00;
    background: #fff9f0;
  }
`;

export const ApplyModalOptionRadio = styled.input`
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 50%;
  background: #fff;
  flex-shrink: 0;
  margin-top: 2px;
  cursor: pointer;

  &:checked {
    border-color: #f38a00;
    background: #f38a00;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10'%3E%3Ccircle cx='5' cy='5' r='2' fill='white'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 10px 10px;
  }
`;

export const ApplyModalOptionText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ApplyModalOptionTitle = styled.span`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 600;
  color: #1e1e1e;
`;

export const ApplyModalOptionDesc = styled.span`
  font-family: Roboto;
  font-size: 13px;
  color: #7f746a;
  line-height: 1.4;
`;

export const ApplyModalSuccessBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
  padding: 8px 0;
`;

export const ApplyModalSuccessIconWrapper = styled.div`
  svg {
    width: 56px;
    height: 56px;
  }
`;

export const ApplyModalSuccessTitle = styled.h3`
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  color: #1e1e1e;
  margin: 0;
`;

export const ApplyModalSuccessButton = styled.button`
  height: 32px;
  padding: 0 28px;
  border-radius: 6px;
  border: none;
  background: #f38a00;
  color: #fff;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const ApplyModalButton = styled.button`
  width: 143px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background: #f38a00;
  color: #fff;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  align-self: flex-start;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// ─── Save Progress / Success Modal ───────────────────────────────────────────

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const SaveModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SaveModalBox = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 360px;
  padding: 32px 24px 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;

  @media (max-width: 767px) {
    max-width: calc(100% - 32px);
  }
`;

export const SaveModalSpinner = styled.div`
  width: 52px;
  height: 52px;
  border: 4px solid #f0ebe8;
  border-top-color: #f38a00;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const SaveModalLoadingText = styled.p`
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  color: #555;
  margin: 0;
`;

export const SaveModalIconWrapper = styled.div`
  svg {
    width: 56px;
    height: 56px;
  }
`;

export const SaveModalTitle = styled.h3`
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  color: #1e1e1e;
  margin: 0;
`;

export const SaveModalSubtitle = styled.p`
  font-family: Roboto;
  font-size: 13px;
  font-weight: 400;
  color: #7f746a;
  margin: 0;
  line-height: 1.55;
`;

export const SaveModalActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-top: 4px;
`;

export const SaveModalSecondaryButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid #d0c8c4;
  background: #fff;
  color: #555;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f5f3f1;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SaveModalPrimaryButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  border-radius: 6px;
  border: none;
  background: #f38a00;
  color: #fff;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
